/**
 * CreateAccountConfirmation.jsx
 * Created by michaelbray on 2/13/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FlexCol, FlexRow } from '../../../sharedComponents/FlexGrid';
import Heading from '../../../sharedComponents/Heading';

const propTypes = {
    email: PropTypes.string
};

export default class CreateAccountConfirmation extends React.Component {
    componentDidMount() {
        this.header.focus();
    }

    render() {
        return (
            <FlexRow justifyContent="center">
                <FlexCol sm={6} md={5} xl={4} className="rec-acct-modal-create-confirmation-body">
                    <div ref={(header) => this.header = header} tabIndex="-1" className="rec-hide-focus">
                        <Heading
                            headingLevel={1}
                            appearance="display"
                            className="rec-acct-modal-title"
                            id="createAccountModalHeading">
                            Check Your Email
                        </Heading>
                    </div>
                    <p>
                        An email has been sent to <strong>{this.props.email}</strong>. Once you confirm your
                        email, you will be able to set a password for your account.
                    </p>
                </FlexCol>
            </FlexRow>
        );
    }
}

CreateAccountConfirmation.propTypes = propTypes;
